import React, { Component } from 'react';
import Dialog from './Dialog';
import tableConfig from './config';
import { validateForm } from '../../common/validation';
import PageView from '../../common/pagination/PageView';
import { AGENT_CONFIG } from '../../common/domain.config';
import * as queryService from '../../common/query.service';
import * as snackService from '../../common/snack.service';
import { ACTION } from '../../../data/enums/enums';
import { BillingSnackBar } from '../../../components/BillingMDC';
import { getValidationErrorMsg } from '../../../views/fundamentals/common/helpers';

export class Agent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        searchBox: false,
        drawer: false,
      },
      snack: { ...snackService.snackParameters },
      queryParameters: { ...queryService.queryParameters },
      dialogType: ACTION.NULL,
      data: {
        list: [],
        total: 0,
      },
      agent: {
        name: '',
        phone: '',
        status:true,
      },
      validation: {
        flag: false,
        fieldList: tableConfig.formValidationFieldList,
      },
    };
  }

  componentDidMount() {
    this.loadTableData();
  }

  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  loadTableData = () => {
    const { getAgentList } = this.props;
    const { queryParameters } = this.state;

    getAgentList(queryParameters).then(response => {
      const { data } = this.state;
      data.list = response.list;
      data.total = response.total;
      this.setState({ data });
    });
  };

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  handleEditIconClick = data => {
    const { agent } = this.state;
    agent.id = data.idAgent;
    agent.name = data.name;
    agent.phone = data.phone;

    this.setState({
      dialogType: ACTION.UPDATE,
      agent,
    });
  };

  handleFabButtonClick = () => {
    const { agent } = this.state;
    agent.name = '';
    agent.phone = '';
    this.setState({
      dialogType: ACTION.ADD,
      agent,
    });
  };

  handleModalSubmit = () => {
    const { agent, validation, dialogType } = this.state;
    const formValid = validateForm(agent, validation, valid => this.setState({ validation: valid }));
    if (!formValid) return false;
    switch (dialogType) {
      case ACTION.ADD:
        this.createAgent();
        break;
      case ACTION.UPDATE:
        this.editAgent();
        break;
      default:
        break;
    }
  };

  createAgent = () => {
    const { create } = this.props;
    const { agent, data } = this.state;

    const agentForRequest = {
      phone: agent.phone.toString(),
      name: agent.name,
    };
    create(agentForRequest)
      .then(response => {
        if(!(response?.doesAgentPreviouslyExist)){
        data.list.push(response.agent);
        data.list.total += 1; // (data.list.total + 1);
        const snack = snackService.generateSuccessMessage();
        this.handleModalClose();
        this.setState({
          data,
          snack,
        });
      }
      else{
        const snack = snackService.generateFailureMessage('Sales Person Already Exist');
        this.handleModalClose();
        this.setState({
          data,
          snack,
        });
      }
      })
      .catch(err => {
        const snack = snackService.generateFailureMessage(getValidationErrorMsg(err));
        this.setState({
          data,
          snack,
        });
      });
  };

  editAgent = () => {
    const { update } = this.props;
    const { agent, data } = this.state;

    update({
      id: agent.id,
      query: {
        name: agent.name,
        phone: agent.phone.toString(),
      },
    })
      .then(res => {
        const updatedDataList = data.list.map(item =>
          item.idAgent === Number(res.agent.id_agent)
            ? {
                ...res.agent,
                idAgent: Number(res.agent.id_agent),
              }
            : item,
        );
        data.list = updatedDataList;
        const snack = snackService.generateUpdateMessage();
        this.handleModalClose();
        this.setState({
          data,
          snack,
        });
      })
      .catch(err => {
        const snack = snackService.generateFailureMessage(getValidationErrorMsg(err));
        this.setState({ snack });
      });
  };

  handleModalClose = () => {
    const { validation } = this.state;
    validation.flag = false;
    this.setState({ dialogType: ACTION.NULL });
  };

  handleInputChange = (field, value,id) => {
    const { agent } = this.state;
    if(field==="status"){
      this.changeStatus(value,id);
      return;
    }
    agent[field] = value;
    this.setState({ agent });
  };


  changeStatus = (checked ,id) => {
    const {updateStatus} = this.props;
    const {data} = this.state;
    const queryData = {
        status: checked,
    };
    updateStatus({
        id,
        query: queryData,
    })
        .then(response => {
            const snack = snackService.generateUpdateMessage();
            const toggleIndex = data.list.findIndex(x => x.idAgent === id );
            data.list[toggleIndex].status = response?.agent?.status;
            this.setState({snack ,data});
        })
        .catch(err => {
            const snack = snackService.generateFailureMessage(err?.error?.message || err?.message );
            this.setState({snack});
        });
  };

  closeSnack = () => {
    const snack = snackService.resetSnack();
    this.setState({ snack });
  };

  render() {
    const { data, display, snack, dialogType, agent, validation } = this.state;

    const { serverResponseWaiting } = this.props;

    return (
      <div className="agents">
        <PageView
          domainConfig={AGENT_CONFIG}
          headerConfig={{
            search: false,
            date: false,
            download: false,
            filter: false,
            create: true,
          }}
          display={display}
          controlDisplay={this.controlDisplay}
          serverResponseWaiting={serverResponseWaiting}
          data={data}
          tableConfig={tableConfig}
          onTableBodyClick={this.handleEditIconClick}
          createHandler={this.handleFabButtonClick}
          onInputChange={this.handleInputChange}
        />

        <Dialog
          actionType={dialogType}
          onModalSubmit={this.handleModalSubmit}
          onModalClose={this.handleModalClose}
          onInputChange={this.handleInputChange}
          agent={agent}
          validationFlag={validation.flag}
        />

        <BillingSnackBar closeSnack={this.closeSnack} config={snack} />
      </div>
    );
  }
}

export default Agent;
